'use strict'

module.exports = require('./colors.json')



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-color-keywords/index.js
// module id = 1497
// module chunks = 0